import { render } from "./MobileDefault.vue?vue&type=template&id=5cce3e46&scoped=true"
import script from "./MobileDefault.vue?vue&type=script&lang=js"
export * from "./MobileDefault.vue?vue&type=script&lang=js"

import "./MobileDefault.vue?vue&type=style&index=0&id=5cce3e46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cce3e46"]])

export default __exports__